import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchgetSiteGates,sendForApproval,getScheduledTicket,
  fetchPmProjectChecklist
} from "services/redux/maintenance/pmList/action";


import {getSiteState} from "../../../services/redux/brandActivtion/sitesListing/action";
import {getSiteData, calculateDistance, getDistanceData, generateHappyCodePM, refreshAfterSiteCheckout} from "../../../services/redux/DistanceCalculator/action";

import {
  getLocationApprovalPending,getCheckLocation
} from "services/redux/installation/siteInspection/action";
import PmProjectSitesCheckList from "./pmProjectSitesCheckList";

const mapStateToProps = (state) => ({
  pmGateData: state.pmListReducer.pmGateData,
  scheduledTickets:  state.pmListReducer.scheduledTickets,
  locationApproval: state.siteInspectionReducer.locationApproval,
  locationCheck : state.siteInspectionReducer.locationCheck,
  siteEnableDisable: state.baSiteListingReducer.siteEnableDisable,
  siteData: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  activeDistanceCheckin: state.loginReducer?.userProfile?.active_distance_checkin || null,
  pmProjectChecklist:state.pmListReducer.pmProjectChecklist
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchgetSiteGates,
      sendForApproval,
      getScheduledTicket,
      getLocationApprovalPending,
      getCheckLocation,
      getSiteState,
      getSiteData,
      calculateDistance,
      getDistanceData,
      generateHappyCodePM,
      refreshAfterSiteCheckout,
      fetchPmProjectChecklist
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmProjectSitesCheckList);
